/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */
import {
  LogLevel,
  Configuration,
  BrowserCacheLocation,
} from "@azure/msal-browser";
import { environment } from "src/environments/environment";

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;
/**
 * Enter here the user flows and custom policies for your B2C application,
 * To learn more about user flows, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1_Angular_SignUpSignIn",
  },
  authorities: {
    signUpSignIn: {
      authority:
        "https://wiplatformapps.b2clogin.com/wiplatformapps.onmicrosoft.com/B2C_1_Angular_SignUpSignIn",
    },
  },
  authorityDomain: "wiplatformapps.b2clogin.com",
};
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: "a57ccc04-dc82-418a-a22e-9a666fa8d960",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: "/", // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge. Remove this line to use Angular Universal
  },
  system: {
    /**
     * Below you can configure MSAL.js logs. For more information, visit:
     * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
     */
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        //console.log(message);
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: true,
    },
    allowNativeBroker: true,
  },
};

export const protectedResources = {
  projectsApi: {
    endpoint: environment.apiURL + "/",
    scopes: ["api://gpd-auth-api/projects-api-scope"],
  },
  graphApi: {
    endpoint: "https://graph.microsoft.com/v1.0/me",
    scopes: ["https://graph.microsoft.com/User.Read.All"],
  },
};

export const loginRequest = {
  scopes: ["api://gpd-auth-api/projects-api-scope"],
};
